module.exports = __webpack_public_path__ + "static/wrsignature-63272fb5f5f02891a378abe9bd5f9ecf.png";